const shadow = 'shadow';
export const aliasShadowBuiltIns = {
    boxShadow: shadow,
    focusRing: shadow,
    topShadow: shadow
};
export const aliasShadow = {
    ...aliasShadowBuiltIns
};

//# sourceMappingURL=aliasShadow.js.map